import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { get, isEmpty } from 'lodash'

import moment from 'moment'
import { Button, Box } from '@material-ui/core'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons'

import ContactHighSchoolCounselorCallToAction from 'components/ContactHighSchoolCounselorCallToAction'

import Icon from '@scoir/components-core/dist/components/Icon'

import useCalendarTransition from 'common/use-calendar-transition'
import { isCredibleDate } from 'common/date'
import scoirLogoIcon from 'icons/scoir-logo.svg'

import helpers from '../Helpers'

import './index.scss'

const Details = ({ onOverviewClose, highSchool }) => {
  const handleTransition = useCalendarTransition(highSchool.Id, highSchool.SchoolName)

  const getCalendarUrl = useMemo(() => {
    const date = moment(get(highSchool, 'NextVisitAvailability')).format('YYYYMMDD')
    return `${import.meta.env.BASE_URL}/recruit/visits/view/week?focus=${date}`
  }, [highSchool])
  const hasFutureAvailability = useMemo(() => {
    const nextAvail = get(highSchool, 'NextVisitAvailability')
    if (isEmpty(nextAvail) || !isCredibleDate(nextAvail)) {
      return false
    }
    const date = moment(nextAvail)
    const startOfToday = moment().startOf('day')
    return date.isAfter(startOfToday)
  }, [highSchool])
  const hs = highSchool
  const isApproved = hs.SystemState === 'approved_state'
  return (
    <div className="selection-details">
      {onOverviewClose && (
        <Box mb={2}>
          <Button
            color="primary"
            variant="outlined"
            size="small"
            onClick={onOverviewClose}
            startIcon={
              <FontAwesomeIcon
                icon={faAngleLeft}
                size="sm"
              />
            }
          >
            Back
          </Button>
        </Box>
      )}

      <div className="high-school-header">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <div>
            <div className="name">{hs.SchoolName}</div>
            {(hs.City || hs.State) && (
              <div className="city-state">{helpers.commaSeparatedList([hs.City, hs.State])}</div>
            )}
          </div>
          {isApproved && (
            <div className="on-scoir">
              <Icon
                className="scoir-visit-icon"
                size="sm"
                def={scoirLogoIcon}
                beforeText
              />
              On Scoir
            </div>
          )}
        </Box>
      </div>
      {isApproved && (
        <div className="buttons">
          <Button
            component={Link}
            to={getCalendarUrl}
            className="availability-button"
            disabled={!hasFutureAvailability}
            size="small"
            variant="contained"
            color="primary"
            onClick={handleTransition}
          >
            View Availability
          </Button>
          <ContactHighSchoolCounselorCallToAction
            variant="outlined"
            color="primary"
            size="small"
            highSchoolId={highSchool.Id}
            highSchoolName={highSchool.SchoolName}
            contactUserId={highSchool.ContactUserId}
          >
            Send Message
          </ContactHighSchoolCounselorCallToAction>
        </div>
      )}
    </div>
  )
}

Details.propTypes = {
  onOverviewClose: PropTypes.func,
  highSchool: PropTypes.object,
  visitDetails: PropTypes.object,
  virtual: PropTypes.bool,
}

export default Details
